import { render, staticRenderFns } from "./FpuiPreviewLightboxImage.vue?vue&type=template&id=148db60c&lang=pug&"
import script from "./FpuiPreviewLightboxImage.vue?vue&type=script&lang=js&"
export * from "./FpuiPreviewLightboxImage.vue?vue&type=script&lang=js&"
import style0 from "./FpuiPreviewLightboxImage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports